import * as React from 'react';
import { useUiConfig } from '../../providers/UiConfigProvider';
import { PopoverConfig } from './PopoverConfig';
import { MobilePopover } from './Popover.mobile';
import { DesktopPopover } from './Popover.desktop';
import { useMediaQuery } from '../../providers/UiMediaQueryProvider';
import { useIsWithinListBoxContext } from '../../iframe-overrides/utils';
export const Popover = PopoverConfig.createView((props)=>{
    const isWithinListBoxContext = useIsWithinListBoxContext();
    const uiConfig = useUiConfig();
    const { isTouch, isSmallScreen } = useMediaQuery();
    const enabledBottomSheets = !!(uiConfig === null || uiConfig === void 0 ? void 0 : uiConfig.enableBottomSheets);
    const isMobileAndBottomSheetEnabled = isSmallScreen && isTouch && enabledBottomSheets;
    const PopoverComponent = isMobileAndBottomSheetEnabled && !isWithinListBoxContext ? MobilePopover : DesktopPopover;
    return /*#__PURE__*/ React.createElement(PopoverComponent, props);
});

//# sourceMappingURL=Popover.js.map